import { useMemo, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api, { loginUser } from "../api";
import "../assets/css/login.css";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isForgot, setIsForgot] = useState(false);
  const [email, setEmail] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  const emailIsValid = useMemo(() => {
    const v = String(email || "").trim();
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  }, [email]);

  const normalizeLoginError = (err) => {
    const code = err?.response?.data?.code || err?.code || "";
    const msg = err?.response?.data?.error || err?.message || "";
    if (code === "MISSING_CREDENTIALS") return "Utente o Password non Inseriti";
    if (code === "USER_LOCKED") return "Utente Bloccato - Troppi Tentativi di Accesso Errato";
    if (code === "IP_TEMPORARILY_BLOCKED") return "IP Temporaneamente Bloccato";
    if (code === "IP_BLOCKED_PERMANENTLY") return "IP Bloccato Permanentemente";
    if (code === "COMPANY_INACTIVE" || /societ|ditta/i.test(msg)) return "Ditta / Società non Attiva";
    if (msg && /Tentativi rimasti/i.test(msg)) return msg;
    if (code === "TENANT_NOT_FOUND") return "Azienda non trovata: verifica il sottodominio configurato";
    if (code === "TENANT_DB_MISSING" || code === "TENANT_DB_INVALID") return "Database aziendale non configurato correttamente";
    if (code === "INVALID_CREDENTIALS") return "Utente e/o Password Errate";
    if (!err?.response || err.response.status >= 500) return "Servizio di accesso non disponibile. Verifica la connessione al server";
    return msg || "Impossibile effettuare l'accesso";
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    if (!String(username || "").trim() || !String(password || "")) {
      setError("Utente o Password non Inseriti");
      return;
    }

    try {
      const data = await loginUser({ username: String(username || "").trim(), password });
      if (data?.user) {
        localStorage.setItem("user", JSON.stringify(data.user));
        if (data.tenant) localStorage.setItem("tenant", JSON.stringify(data.tenant));
        navigate(location.state?.from?.pathname || "/app/dashboard", { replace: true });
      } else {
        setError("Utente e/o Password Errate");
      }
    } catch (err) {
      setError(normalizeLoginError(err));
    }
  };

  const handleForgot = async (e) => {
    e.preventDefault();
    setError("");
    const mail = String(email || "").trim();

    if (!emailIsValid) {
      setError("Inserisci una mail valida");
      return;
    }

    try {
      await api.post("/api/forgot-password", { email: mail });
      setEmail("");
      setUsername("");
      setPassword("");
      setError("");
      setIsForgot(false);
    } catch {
      setError("Inserisci una mail valida");
    }
  };

  return (
    <main className="login_container">
      <div className="login_wrapper">
        <div className="logo_container">
          <div className="logo_img" aria-hidden="true" />
          <div className="logo_wrt" aria-hidden="true" />
        </div>

        <div className={`login_form ${isForgot ? "login_form_reset" : "login_form_access"}`}>
          <h1>{isForgot ? "RESETTA CREDENZIALI" : "Login"}</h1>

          {!isForgot ? (
            <>
              <form className="login_state_form" onSubmit={handleLogin} noValidate>
                <div className="login_content_slot login_access_fields">
                  <div className="input_group">
                    <label htmlFor="username">Username</label>
                    <input id="username" name="username" type="text" placeholder="Inserisci l'utente" autoComplete="username" value={username} onChange={(e) => setUsername(e.target.value)} required />
                  </div>
                  <div className="input_group input_group_password">
                    <label htmlFor="password">Password</label>
                    <input id="password" name="password" type="password" placeholder="Inserisci la password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                  </div>
                </div>
                <div className="login_notice_slot">
                  {error ? <p className="login_error">{error}</p> : <p className="login_notice">Inserire Utente e Password per accedere</p>}
                </div>
                <div className="login_button_slot">
                  <button type="submit">Login</button>
                </div>
              </form>

              <a className="login_bottom_link" href="#" onClick={(e) => { e.preventDefault(); setError(""); setIsForgot(true); }}>
                Dimenticato la Password?
              </a>
            </>
          ) : (
            <>
              <form className="login_state_form" onSubmit={handleForgot} noValidate>
                <div className="login_content_slot login_reset_fields">
                  <p className="forgot_text">
                    Inserire la mail collegata all&apos;utente per ricevere il link di rigenerazione password, ricrearla e poter eseguire il login senza problemi
                  </p>
                  <div className="input_group">
                    <label htmlFor="email">Email</label>
                    <input id="email" name="email" type="email" placeholder="Inserisci la mail" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                  </div>
                </div>
                <div className="login_notice_slot">
                  {error ? <p className="login_error">{error}</p> : <span className="login_notice">&nbsp;</span>}
                </div>
                <div className="login_button_slot">
                  <button type="submit" className="forgot_submit_btn">Invia</button>
                </div>
              </form>

              <a className="login_bottom_link" href="#" onClick={(e) => { e.preventDefault(); setError(""); setEmail(""); setIsForgot(false); }}>
                Torna al Login
              </a>
            </>
          )}
        </div>
      </div>
    </main>
  );
}
